import type { QueryClient } from '@tanstack/react-query';
import { notFound } from '@tanstack/react-router';
import { featuresQuery } from '@/features/feature-flags/use-feature';

/**
 * Route guard (beforeLoad): projects ship behind the `projects` feature flag until released.
 * Routing convenience only – the API checks permissions on every request.
 */
export async function requireProjectsFeature(queryClient: QueryClient): Promise<void> {
  const { flags } = await queryClient.query(featuresQuery);
  if (!flags.projects) throw notFound();
}
